<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>盗用・剽窃チェック</h1>
                        <h2>Trinkaの<br/>盗用・剽窃チェック</h2>
                        <p>Trinka（トリンカ）は、インターネットや有料公開されている論文およびコンテンツとの照合で、盗用や剽窃にあたる箇所がないかを数分で包括的にチェックします。</p>
                        <a href="https://cloud.trinka.ai/dashboard/plagiarism-check" id="autoEditGetStart" target="_blank">今すぐチェックする</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                        <img src="../../../assets/images/plagiarismCheckBannerImg.png" alt="盗作チェック - 文法 チェック">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="userDataSection">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="userDataContent FirstuserDataContent">
                    <span class="top-features">おすすめポイント</span>
                    <h3>82+ <span>Million</span></h3>
                    <p>購読型の<br/> 学術論文数</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="userDataContent">
                    <h3>91+ <span>Billion</span></h3>
                    <p>アーカイブ・<br/>公開中合わせた<br/>ウェブページ数</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="userDataContent">
                    <h3>135+ <span style="padding-left: 5px;">Million</span></h3>
                    <p>オープンアクセス<br/> 論文数</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="userDataContent">
                    <h3>102+ <span style="padding-left: 5px;">Million</span></h3>
                    <p>1日あたりの <br/>自動ページ<br/>クロール数</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="compaireSections">
    <div class="container">
        <div class="row ">
            <div class="col-sm-12 col-md-12 col-lg-9">
                <h2>お客様のニーズに合わせた<br/>3種類の盗用・剽窃チェックレポート</h2>
                <div class="HeadingSubLine"></div>
                <p>Trinkaでは、お客様の文章に最適な3種類の剽窃チェックレポートを、適切な価格で提供します。</p>
            </div>
            <div class="col-lg-3">
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-4">
                <div class="compairePartOne ">
                    <h3>盗用・剽窃スコア（無料）</h3>
                    <ul>
                        <li>盗用・剽窃スコア算出と出典の概要</li>
                        <li>インターネット、オープンアクセス、<span class="yellow-bg">購読型ジャーナル</span>の広範なデータベースを参照</li>
                        <li>盗用度合いの把握と、上位プランが必要かの判断材料に最適</li>
                        <li>プレミアムプランでは1か月あたり2回まで無料利用可（ベーシックプランでは1回のみ）</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 col-lg-4">
                <div class="compairePartOne compairePartTwo">
                    <h3>Trinka 盗用・剽窃レポート</h3>
                    <ul>
                        <li>インターネット上の情報およびオープンアクセス出版物との比較チェック</li>
                        <li>日々更新されるデータベースと優れた検出技術が保証する高い精度</li>
                        <li>ジャーナル投稿以外の一般文書に最適</li>
                        <li>12ポイントで1レポートを生成 </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 col-lg-4">
                <div class="compairePartOne compairePartTwo">
                    <h3>iThenticate<sup style="font-size: 12px;">&#174;</sup> 盗用・剽窃レポート</h3>
                    <ul>
                        <li>インターネット、オープンアクセスおよび<span class="yellow-bg">購読型ジャーナル</span>との照合 </li>
                        <li>多くの学術出版社が信頼する、更新を続ける世界最大級のデータベースと高度な技術</li>
                        <li>ジャーナル投稿予定の論文に最適</li>
                        <li>18ポイントで1レポートを生成 </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-md pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>盗用・剽窃チェックレポートのサンプル</h2>
                    <div class="HeadingSubLine"></div>
                    <p>3種類のレポートがどのようなものか、サンプルをご覧ください。 </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="smp-report">
                    <div class="row match-box">
                        <div class="col-12 dflex">
                            <div class="smp-content">
                                <div class="smp-body">
                                    <h3>盗用・剽窃スコア（無料）</h3>
                                    <p>インターネット上の文献、オープンアクセスの出版物、さらに<span class="yellow-bg">購読型の出版物</span>を参照し原稿を検証した結果の盗用・剽窃スコアを提示します。他2つの上位プランをご利用になる前に、論文の盗用・剽窃の度合いを把握できます。</p>
                                </div>
                                <div class="smp-img bb-1">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="media">
                                                <div class="media-left">
                                                    <div class="svg-item">
                                                        <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                                          <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>
                                                          <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"></circle>
                                                          <circle class="donut-segment" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5" stroke-dasharray="47 53" stroke-dashoffset="25"></circle>
                                                          <g class="donut-text">
                                                      
                                                            <text y="50%" transform="translate(0, 2)">
                                                              <tspan x="50%" text-anchor="middle" class="donut-percent">47%</tspan>   
                                                            </text>
                                                          </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div class="media-body">
                                                    <h3>Trinka Plagiarism Checker - Sample.docx</h3>
                                                    <em>Generated on: Jun 7, 2022, 6:33:30 PM</em>
                                                    <span><img src="../../../../assets/images/delete_smp.png" alt="アイコン - 英文校正"/></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="rp-details">
                                                <h3>Score Details</h3>
                                                <div class="score-details">
                                                    <p><b>Overall match (all sources) <span>47%</span></b></p>
                                                    <ul class="mj-sitemap">
                                                        <li class="hide-li">&nbsp;</li>
                                                        <li>Internet Source <span>41%</span></li>
                                                        <li>Paid Publications <span>26%</span></li>
                                                    </ul>
                                                    <p>56 words match with top 5 sources</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="rp-details">
                                                <h3>Analysis</h3>
                                                <div class="analysis-details">
                                                    <h6><span><img src="../../../../assets/images/exclamation.png" alt="アイコン - ai英文校正" /></span>Critical</h6>
                                                    <p>The document seems to contain numerous instances of high similarity with published/Internet content. Use the iThenticate report to find sources minimize similarity.</p>                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="rp-details">
                                                <h3>Next Steps</h3>
                                                <div class="steps-details">
                                                    <div class="step-card">
                                                        <h6>Buy iThenticate Plagiairsm Report</h6>
                                                        <em>(9 Credits)</em>
                                                        <span class="recommended">Recommended</span>
                                                    </div>                                                  
                                                </div>
                                                <div class="steps-details">
                                                    <div class="step-card">
                                                        <h6>Buy Trinka Plagiairsm Report</h6>
                                                        <em>(6 Credits)</em>
                                                    </div>                                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <div class="smp-content mt_4">
                                <div class="smp-body">
                                    <div class="row align-items-center">
                                        <div class="col-12 col-lg-7">
                                            <h3>Trinka 盗用・剽窃レポート</h3>
                                        </div>
                                    </div>
                                    <p>このチェックはジャーナルでの出版以外の出版や情報発信にお使いになる原稿のチェックに適しています。インターネット上の情報に加え、オープンアクセスの出版物も参照して類似した内容がないかをチェックします。</p>
                                </div>
                                <div class="smp-img1">
                                    <img src="../../../../assets/images/trinka-plagiarism-check.png" class="img-fluid" alt="Trinka 盗作チェック - 英文校正"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 dflex">
                            <div class="smp-content mt_4">
                                <div class="smp-body">
                                    <div class="row align-items-center">
                                        <div class="col-6 col-lg-7">
                                            <h3>iThenticate<sup>®</sup>盗用・剽窃レポート</h3>
                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <a href="https://www.trinka.ai/jp/assets/images/reports/Trinka-Plagiarism-Checker-Sample-ithenticate.pdf" class="sample-download" download="">
                                                <div class="media">
                                                    <div class="media-left">
                                                        <img src="../../../../assets/images/download.svg" alt="ダウンロード - 英文校正" />
                                                    </div>
                                                    <div class="media-body">
                                                       <p>サンプルをダウンロード</p> 
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <p>ジャーナル投稿予定の論文のチェックに最適です。インターネット上の情報、オープンアクセスの出版物、さらに<span class="yellow-bg">購読型の出版物</span>を参照し原稿を検証します。<br class="d-none d-lg-block d-md-block"/> &nbsp;</p>
                                </div>
                                <div class="smp-img1">
                                    <img src="../../../../assets/images/iThenticate-plagiarism-check.png" class="img-fluid" alt="iThenticate 盗作チェック - 文法 チェック" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="cloud_key_features cloudKeyBenefitSection">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading">
                    <h2>盗用・剽窃チェックのメリット</h2>
                    <div class="HeadingSubLine"></div>
                    <p class="mb-2">盗用・剽窃チェックの各種機能をご利用いただくことで、意図せぬ盗用・剽窃を防ぎ、自信を持って英文を公開できます。</p>
                </div>
            </div>
        </div>
        <div class="row match-box">

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards c-card">
                    <img src="../../../assets/images/languageScore_icon.svg" alt="言語スコア - 英文校正">
                    <h3>無料の盗用・剽窃スコア</h3>
                    <p>盗用・剽窃の度合いと出典の概要を無料で取得できます。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards c-card">
                    <img src="../../../assets/images/Easy_understand_report.svg" alt="簡単なレポート - 英文 チェック">
                    <h3>わかりやすいレポート</h3>
                    <p>出典ごとに色分け表示された、直感的に理解できるPDFレポートを生成します。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards c-card">
                    <img src="../../../assets/images/Internet-Paid.svg" alt="インターネット - 英文チ ェッカー">
                    <h3>インターネットに加え有料出版物も参照</h3>
                    <p>8200万件以上の有料刊行物とインターネットコンテンツのデータベースで、強固なチェックを実現します。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards c-card">
                    <img src="../../../assets/images/Superior_Technology.svg" alt="テクノロジー - 文法 チェック">
                    <h3>優れた検出技術</h3>
                    <p>大手学術出版社で採用されている盗用・剽窃検出テクノロジーが、引用箇所と盗用・剽窃の恐れのある箇所とを識別し、信頼性の高い結果を提供します。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards commingSoonTag c-card">
                    <!-- <img src="../../../assets/images/style_guide_icon.svg" alt=""> -->
                    <img src="../../../assets/images/RetainOriginalFormatting.png" alt="書式設定 - 英文校正">
                    <h3>毎日のデータベース更新</h3>
                    <p>包括的で広範なデータベースは毎日更新され、新しい情報ソースや変更を取り入れた結果を提供します。</p>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-6">
                <div class="features_cards commingSoonTag">
                    <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="">
                    <h3>Subject Area & Document Type</h3>
                    <p>Customize Trinka to provide you the most relevant suggestions based on your subject area and
                        type of manuscript.</p>
                </div>
            </div> -->

        </div>
    </div>
</div>

<div class="section-md pb-30">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-tl">
                    <h2>iThenticate<sup>®</sup> 盗用・剽窃レポートが選ばれる理由 </h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="section-tl">
                    <p>TrinkaのiThenticate盗用・剽窃レポートは、最もパワフルなアルゴリズムと<span class="yellow-bg">最もリッチな出版物データベース</span>を組み合わせることにより、信頼性の高い剽窃検出を実現しています。このデータベースには、全てのオープンアクセスレポジトリーや利用可能な全てのインターネットコンテンツも含まれています。</p>
                    <p>Elsevier（エルゼビア）、Wiley（ワイリー）、Springer Nature（シュプリンガーネイチャー）、Taylor & Francis（テイラー＆フランシス）、Sage（セイジ）を含む1,700以上の出版社の既刊論文とご自分の論文原稿を簡単に比較いただけます。</p>
                    <h3 class="sm-title-pc">主なユーザー層</h3>
                    <div class="pc-sub-container">
                        <div class="row">
                            <div class="col-6">
                                <div class="media">
                                    <div class="media-left">
                                        <img src="../../../../assets/images/student_icon.png" alt="学生 - 英文校正 " />
                                    </div>
                                    <div class="media-body">
                                        <h3>学生</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="media">
                                    <div class="media-left">
                                        <img src="../../../../assets/images/faculty_icon.png" alt="学部 - 文法 チェック" />
                                    </div>
                                    <div class="media-body">
                                        <h3>教員</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="media">
                                    <div class="media-left">
                                        <img src="../../../../assets/images/university_reviewer.png" alt="大学評論家 - 英文チ ェッカー" />
                                    </div>
                                    <div class="media-body">
                                        <h3>査読者</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="media">
                                    <div class="media-left">
                                        <img src="../../../../assets/images/researcher.png" alt="研究者 - ai英文校正 " />
                                    </div>
                                    <div class="media-body">
                                        <h3>研究者</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="document-type">
                    <h3>幅広い種類の文書に対応</h3>
                    <div class="img">
                        <img src="../../../../assets/images/document-types.jpg" alt="カバー - 文法 チェック" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- 
<div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading">
                    <h2>iThenticate® 盗用・剽窃レポートのサンプル</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
                <div class="viewSampleReportImg">
                    <a href="https://www.trinka.ai/assets/resources/Trinka_Plagiarism_Check_Sample_report.pdf" target="_blank">サンプルの全文を見る <i class="fa fa-arrows-alt" aria-hidden="true"></i></a>
                    <img src="https://www.enago.com/plagiarism-checker/images/article-right.png" alt="Plagiarism check sample report">
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="use_trinka_other_app accomplishBrilliantWrap">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>一流出版社や査読者からの信頼がここに</h2>
            <a href="https://cloud.trinka.ai/dashboard/plagiarism-check" target="_blank">今すぐチェックする</a>
        </div>
    </div>
</div>

<div class="section-md">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-lg-6">
                <div class="section-tl">
                    <h2>世界1,700以上の出版社が利用</h2>
                    <div class="HeadingSubLine"></div>
                    <p>TrinkaのiThenticate® 盗用・剽窃チェックツールは、1700以上の出版社・査読者によって世界中で使用されているiThenticateの膨大なデータベースとアルゴリズムを利用しています。</p>

                    <p>非常に精度の高いテキスト類似性検出アルゴリズムで、原稿の独自性と信頼性を検証します。Elsevier、Wiley、Springer Nature、Taylor & Francis、Sageなどの出版社から刊行された論文を参照し、類似した点がないかをチェックします。</p>
                    
                </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 text-center">
               <img src="../../../../assets/images/plagiarism-check-map.jpg" class="img-fluid" alt="盗作チェックマップ - 文法 チェック" />
            </div>
        </div>
    </div>
</div>

<div class="section-md bg-grey">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>Trinkaの盗用・剽窃チェックで高精度の原稿査定を</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-lg-6">
                <div class="section-tl">
                    <p>数多くの盗用・剽窃チェックツールの中から、適切なものを選び出すのは簡単なことではありません。どの盗用・剽窃チェックツールを使うべきかお悩みの皆様のために、主要な盗用・剽窃チェッカーの比較を行いました。その結果、Trinkaは信頼、正確性でもっとも優れた結果を出しました。</p>

                    <p>盗用・剽窃にあたる箇所が多数あるサンプル論文を用意し、これを用いてテストを行ったところ、Trinkaの盗用・剽窃チェックツールが、他のほとんどのツールを凌駕する結果を出しました。</p>

                    <p>主要な10個のツールを、精度、データベースサイズ、アクセシビリティ、使いやすさ、コスト、セキュリティおよび言語の質の向上という7つの指標に基づき比較した結果、Trinkaの優位性が分かりました。Trinkaは、データを安全に保ちつつ、高い専門性と精度で論文のチェックを行います。</p>

                </div>
            </div>
            <div class="col-md-6 col-sm-12 col-lg-6 text-center">
                <div class="graph-pc">
                    <img src="../../../../assets/images/plagiarism-check-graph.png" class="img-fluid" alt="盗作チェックマップ - 文法 チェック" />
                </div>
                <h3 class="graph-bottom-title">Trinka自社調べ、2022年）</h3>
            </div>
        </div>
    </div>
</div>

<div class="allAboutTrinkaCredit">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="aboutTrinkaCreditHeading">
                    <h2>盗用・剽窃チェックレポート生成にはポイント（Credit）が必要です</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="creditSectionFeature">
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">ご利用いただくTrinkaの機能に応じ、ポイントが消費されます。</p>
                        <p>プレミアムプランをご利用の方には10ポイント、ベーシックプランをご利用の方には4ポイントが毎月無料で付与されます。詳しくは<a [routerLink]="['/features/credits']" class="text-link">こち</a>らをご覧ください。</p>
                    </div>
                    <div class="featurePointsCredits">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" alt="アイコン - 文法 チェック">
                        </span>
                        <p>Trinka 盗用・剽窃レポートは12ポイント、iThenticate<sup>®</sup> 盗用・剽窃レポートは18ポイントでご利用可。ご利用プランのアカウントに無料で付与されるポイントに加え、必要に応じて追加でご購入もいただけます。</p>
                    </div>
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">プレミアムプランをご利用のお客様は毎月2回、無料で盗用・剽窃スコアチェックをご利用いただけます。</p>
                        <p>さらに、ポイント・パック（Credit Pack）ご購入の際に最大40%の割引が適用されます。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="SectionHowItWrok">
    <div class="container">
        <div class="row">
            <div class="col-xl-6">
                <div class="ImgSectionHowItWrok">
                    <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                        <img src=".././../../assets/images/PlagCheckThumbnail.png" alt="盗作チェック - 英文チ ェッカー " class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="contentSectionHowItWrok">
                    <h2>盗用・剽窃チェックの使い方</h2>
                    <div class="HeadingSubLine"></div>
                    <p style="margin-bottom: 10px;">わかりやすいウォークスルービデオで、Trinkaの盗用・剽窃チェック機能をステップごとに解説します。</p>
                    <p><a style="color: #0000ff;" (click)="scroll(target)" class="text-link">FAQ</a>もあわせてお読みください。</p>
                </div>
            </div>
            
        </div>
    </div>
</div>

<div class="section-md pb-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>有償版と無償版の盗用・剽窃チェックツール比較</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class=" table-responsive">
                    <table class="table-bordered compare_tabels table">
                        <thead>
                            <tr>
                                <th colspan="2" bgcolor="#f9f9f9">
                                    盗用・剽窃
                                </th>
                                <th align="center" class="text-center">
                                    Trinkaの有料盗用・剽窃チェックツール
                                </th>
                                <th align="center" class="text-center">
                                    他の無料盗用・剽窃チェックツール
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td bgcolor="#f9f9f9" colspan="2"><b>結果の正確性と信頼性</b></td>
                                <td align="center">高</td>
                                <td align="center">低</td>
                            </tr>
                            <tr>
                                <td bgcolor="#f9f9f9" colspan="2"><b>データベースの更新頻度</b></td>
                                <td align="center">毎日</td>
                                <td align="center">定期的</td>
                            </tr>
                            <tr>
                                <td bgcolor="#f9f9f9" rowspan="2"><b>データベースサイズ</b></td>
                                <td bgcolor="#f9f9f9"><b>対象インターネットページ</b></td>
                                <td align="center">数十億規模の公開中およびアーカイブ済みウェブページ</td>
                                <td align="center">データベースサイズに制限あり。ほとんどが公開中のページのみ</td>
                            </tr>
                            <tr>
                                <td bgcolor="#f9f9f9"><b>対象となる購読型の学術論文</b></td>
                                <td align="center">すべてのオープンアクセスおよび<span class="yellow-bg">有料の学術出版物</span></td>
                                <td align="center">ライセンス費用の掛かる有料記事は含まれない</td>
                            </tr>
                            <tr>
                                <td bgcolor="#f9f9f9" colspan="2"><b>セキュリティ</b></td>
                                <td align="center">安全</td>
                                <td align="center">脆弱</td>
                            </tr>
                            <tr>
                                <td bgcolor="#f9f9f9" colspan="2"><b>データ保存</b></td>
                                <td align="center">ツールへのデータ保存なし</td>
                                <td align="center">ツールにデータを保存</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>よくあるご質問</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    Trinkaの盗用・剽窃チェックはどうやって使えばいいのですか？</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <p class="mb-2">Trinkaの盗用・剽窃チェックの使い方はとても簡単です。</p>
                                    <ol>
                                        <li>まずはTrinkaのアカウントにアクセス（無料アカウントへの登録がお済みでない方は<a href="https://cloud.trinka.ai/signup" target="_blank" class="text-link">こちら</a>よりご登録ください）</li>
                                        <li>左側のパネルから「Plagiarism Check」をクリック</li>
                                        <li>文書をアップロードし、内容に応じてご希望プランを選択。既にTrinkaのドライブにアップロード済みのファイルも選択可</li>
                                        <li>数分でスコアを抽出/詳細な盗用・剽窃チェックレポートを生成</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    Trinkaの盗用・剽窃チェックは他のツールとどう違うのですか？</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>他のツールとは異なり、Trinkaでは参照するデータベースを、インターネットコンテンツのみや、インターネットと有料出版物との両方など、お客様のニーズに合わせて選択することができます。iThendicateとの提携によって実現したTrinkaの優れた検出テクノロジーは、世界の大手学術出版社から信頼いただいています。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionThree">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                    aria-controls="QuestionThreeContent">
                                    Trinkaの盗用・剽窃チェックは無料で利用できますか？
                                </a>
                            </div>

                            <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                <div class="card-body">
                                    <!-- <p>Yes. All Basic users get 1 free Plagiarism Score every month. All Premium users get 2 free Plagiarism Score checks every month. You can run as many checks as you like with <a [routerLink]="['/features/credits']">credits</a>.</p> -->
                                    <p class="mb-2">盗用・剽窃スコアのチェックは無料でご利用いただけます。</p>
                                    <p>ベーシックプランをお使いの場合毎月1回、プレミアムプランをお使いの場合は毎月2回、盗用・剽窃スコアのチェックを無料でご利用いただけるに値するポイント（Credit）が自動付与されます。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    盗用・剽窃チェックのレポートはダウンロードできますか？
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>はいできます。生成されたレポートはPDF形式でいつでもダウンロードすることが可能です。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/Mc_EZXIzvFU"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal" id="freePlagiarismScore">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header bb-none">
          <h4 class="modal-title">Sample Score</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          <img src="../../../../assets/images/reports/report_list_item.png" alt="reports-list" class="img-fluid" />
        </div>
      </div>
    </div>
</div>